import React, { Component, useEffect, useState } from 'react';
import Select from '@vromo/ui/components/Select2';
import queryString from 'query-string';

import { runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';

import { useStore } from '@vromo/mobx-react';

import FontAwesome from '@vromo/ui/components/FontAwesome';
import { RootStore } from '../stores/RootStore';
import { Role } from '@vromo/models';
import { EntityList } from '@vromo/models';
import useRouter from '@vromo/hooks/useRouter';
import Button from '@vromo/ui/components/Button';
import sortBy from 'lodash/sortBy';
import theme from '@vromo/ui/components/theme';
import useAuth from '../useAuth';
import { InputLabel } from '@vromo/ui/components/Input';

export default observer(function OAuthPassthrough(props: any) {
    const [roles, setRoles] = useState<Array<Role>>([]);
    const [role, setRole] = useState<Role>();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const roleOptions = sortBy(
        roles.map((r) => ({ label: r?.group?.name, value: r.id })),
        (r) => r.label
    );

    const query = queryString.parse(props.location.search);

    const {
        authStore,
        authStore: { graph, api, token }
    } = useStore<RootStore>('rootStore');

    const { history } = useRouter();

    useEffect(() => {
        if (authStore.authenticated) {
            setIsLoading(true);
            graph.root
                .graph()
                .roles()
                .get()
                .then(({ items }) => {
                    runInAction(() => {
                        setRoles(items);
                        if (items.length > 0) setRole(items[0]);
                        setIsLoading(false);
                    });
                });
        }
    }, []);

    const deny = () => {
        history.push('/logout');
    };

    const authorize = () => {
        const body = {
            group: role?.group?.id ?? 0,
            client: String(query.client_id)
        };

        api.oAuthAuthorize.post(body, undefined, token).then((result) => {
            if (!result.success) return;
            const { data: authToken } = result;
            const code = query.redirect_uri.includes('?') ? `&code` : `?code`;

            window.location.replace(
                `${query.redirect_uri}${code}=${encodeURIComponent(authToken)}`
            );
        });
    };

    if (isLoading) {
        return (
            <div>
                <FontAwesome icon="spinner" spin />
            </div>
        );
    } else {
        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: 30
                }}>
                <div style={{ maxWidth: 500 }}>
                    <h3>Allow this application to authenticate with your Vromo account?</h3>

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>
                                    <strong>Client ID</strong>
                                </td>
                                <td>{query.client_id}</td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Redirect URI</strong>
                                </td>
                                <td>{query.redirect_uri}</td>
                            </tr>
                        </tbody>
                    </table>

                    {roles.length > 1 ? (
                        <div style={{ margin: '16px 0' }}>
                            <InputLabel label="Select Role to Authenticate With:">
                                <Select
                                    placeholder="Group"
                                    value={roleOptions.find((r) => r.value == role?.id)}
                                    options={roleOptions}
                                    onChange={(selectedRole) =>
                                        setRole(roles.find((role) => role == selectedRole.value.id))
                                    }
                                />
                            </InputLabel>
                        </div>
                    ) : null}

                    <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: 50 }}>
                        <Button destructive onClick={deny}>
                            Deny
                        </Button>
                        <Button
                            data-test-id="oauth-allow"
                            color={theme.success}
                            onClick={authorize}>
                            Allow
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
});
